export default "__VITE_ASSET__Bo9bqMNb__"